module.exports = __webpack_public_path__ + "5dbc7cd591152655ca0fab3fd72ffd16.svg";